import ViewFeedbacks from "../feedback/View";
import CreatedFeedbacks from "../feedback/Create";

const feedbackRoutes = [
  { path: "/feedback", component: CreatedFeedbacks },
  { path: "/feedback-view", component: ViewFeedbacks },
];

export default feedbackRoutes;
